import { Component, Input } from "@angular/core";

@Component({
    selector: "user-banner",
    template: `
        <div class="banner-box"
             [ngClass]="{ 'alert-banner': type === 'alert',
                          'warning-banner': type === 'warning',
                          'success-banner': type === 'success' }">
            <span class="banner-msg-container flex-container">
                <i class="far banner-icon"
                   [ngClass]="{ 'fa-circle-xmark': type === 'alert',
                                'fa-exclamation-circle': type === 'warning',
                                'fa-check-circle': type === 'success' }">
                </i>
                <span>
                     <span class="top-text" test-id="banner-msg-top">
                        {{ topText }}
                     </span>
                     <div class="bottom-text" test-id="banner-msg-bottom">
                        {{ bottomText }}
                     </div>
                 </span>
            </span>
        </div>
    `,
    styles: [`
        @import "/src/styles/colors";
        @import "/src/styles/settings";

        .banner-box {
            margin-top: 16px;
            border: 1px solid;
            border-radius: 2px;
            padding-bottom: 12px;
            padding-right: 12px;
            margin-bottom: 16px;

            &.warning-banner {
                background-color: $autumn-orange-1;
                border-color: $autumn-orange-4;

                .banner-icon {
                    color: $autumn-orange-6;
                }
            }

            &.alert-banner {
                background-color: $cinnabar-red-1;
                border-color: $cinnabar-red-4;

                .banner-icon {
                    color: $cinnabar-red-6;
                }
            }

            &.success-banner {
                background-color: $grass-green-1;
                border-color: $grass-green-4;

                .banner-icon {
                    color: $grass-green-6;
                }
            }
        }

        .banner-msg-container {
            margin-top: 12px;
        }

        .banner-icon {
            margin-left: 16px;
            margin-right: 16px;
            font-size: 1.5rem;
        }

        .top-text {
            color: $gray-9;
            font-size: 1rem;
        }

        .bottom-text {
            color: $gray-9;
            font-size: 0.875rem;
        }
    `],
})
export class UserBannerComponent {
    @Input() topText: string;
    @Input() bottomText: string;
    @Input() type: "warning" | "alert" | "success" = "warning";
}
